module.exports = __webpack_public_path__ + "static/media/ic_menu_k.830749db.svg";